module.exports = __webpack_public_path__ + "img/konfortify-review-grid.6a986da9.png";